import React, { useEffect } from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";
import Specification from "./Specification.jsx";
import { useSelector, useDispatch } from "react-redux";
import { updateOverview } from "../../state/reducers/codeOverview";
import { resetSpecification } from "../../state/reducers/CodeSpecification.js";

function CodeSpecification() {

  const showOverview = useSelector((state) => state.codeOverview.showOverview)
  const showSpecification = useSelector((state) => state.CodeSpecification.showSpecification)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateOverview(false))
    return (() => {
      dispatch(resetSpecification())
    })
  }, [])

  return (
    <>
      {!showOverview && !showSpecification && <CloneRepo />}
      {showSpecification && <Specification />}
    </>
  );
}

export default CodeSpecification;